import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { UserService } from '../../../services/UserService';

export interface Props {
}

interface State {
    AncienMotDePass: string;
    NouveauMotDePass: string;
    ConfirmationMotDePass: string;
}

/**
 * Ce composant permet la modification du mot de passe correspondant à ce profil
 */
export class ModifMdpProfile extends React.Component {
    props: Props;
    state: State;
    backupProfil: ReqType.UserView;

    constructor(props: Props) {
        super(props);
        this.state = {
            AncienMotDePass: '',
            NouveauMotDePass: '',
            ConfirmationMotDePass: '',
        };
    }

    render() {
        return (
            <div className="card card-default">
                <div className="card-header col-12">
                    <h4 className="text-white">
                        <strong> Modification de mot de passe </strong>
                    </h4>
                </div>

                <div className="card-body">
                    <this.DisplayInformation />
                </div>

                <div className="card-footer" >
                    <div className="container-fluid justify-content-end" style={{ display: 'flex' }}>
                        <button
                            className="btn btn-outline-danger btn-lg"
                            onClick={
                                () => {
                                    this.setState(
                                        {
                                            AncienMotDePass: '',
                                            NouveauMotDePass: '',
                                            ConfirmationMotDePass: '',
                                        });
                                }
                            }

                        >
                            Abandonner
                        </button>
                        <LoaderButton
                            className="btn btn-lg"
                            onClick={this.sendServer}
                            style={{marginLeft: '20px'}}
                            confirmation={true}
                            modalTitle="Changé le mot de passe"
                            modalBody="Etes vous certain de vouloir changer votre mot de passe ?"
                            disabled={
                                this.state.NouveauMotDePass !== this.state.ConfirmationMotDePass ||
                                this.state.NouveauMotDePass.length < 6
                            }
                        >
                            Valider
                        </LoaderButton>
                    </div>
                </div>
            </div>
        );
    }

    private DisplayModifMotDePasse() {
        const liClass = 'list-group-item list-group-item-danger';
        return (
            <li className={liClass}>
                <input
                    className="form-control form-control-lg col-12"
                    placeholder="Ancien Mot De Passe"
                    value={this.state.AncienMotDePass}
                    style={{marginBottom: '10px'}}
                    onChange={
                        (e: React.ChangeEvent<HTMLInputElement>) => {
                            this.setState({ AncienMotDePass: e.target.value });
                        }
                    }
                    name="AncienMotDePass"
                    type="password"
                />
                <input
                    className="form-control form-control-lg col-12"
                    placeholder="Nouveau Mot De Passe"
                    style={{marginBottom: '10px'}}
                    value={this.state.NouveauMotDePass}
                    onChange={
                        (e: React.ChangeEvent<HTMLInputElement>) => {
                            this.setState({ NouveauMotDePass: e.target.value });
                        }
                    }
                    name="NouveauMotDePass"
                    type="password"
                />
                <input
                    className="form-control form-control-lg col-12"
                    placeholder="Confirmation Du Nouveau Mot De Passe"
                    value={this.state.ConfirmationMotDePass}
                    onChange={
                        (e: React.ChangeEvent<HTMLInputElement>) => {
                            this.setState({ ConfirmationMotDePass: e.target.value });
                        }
                    }
                    name="ConfirmationMotDePass"
                    type="password"
                />
            </li>
        );
    }

    // affichage des informations du titulaire du compte.
    private DisplayInformation = () => {
        return (
            <div className="col-12">
                <ul className="list-group">
                    {this.DisplayModifMotDePasse()}
                </ul>
            </div>
        );
    }

    // Mise en ligne
    private sendServer = () => {
        return UserService.getInstance().changeOwnPassword(
            this.state.AncienMotDePass,
            this.state.NouveauMotDePass
        ).then(
            () => {
                alert('Le mot de passe a été changé');
            }
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/ModifMdpProfile.tsx